import { useNavigationMenu } from '@/components/Menu/useNavigationMenu';
import Menu from 'antd/es/menu';
import { css, styled } from 'styled-components';

const StyledSideBarContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const StyledMenu = styled(Menu)<{ inlineCollapsed: boolean }>`
  ${({ theme, inlineCollapsed }) => css`
    /* Add spacing between group labels and their children */
    .ant-menu-item-group-title {
      padding: ${theme.paddingSM}px ${theme.padding}px ${theme.paddingXS}px;
      margin-top: ${theme.marginSM}px;
    }

    /* Hide group titles completely when collapsed */
    ${inlineCollapsed &&
    css`
      .ant-menu-item-group-title {
        display: none;
      }
    `}
  `}
`;

export const SideBarContent = ({ isCollapsed }: { isCollapsed: boolean }) => {
  const { items, selectedKeys } = useNavigationMenu({
    mode: 'sidebar',
  });

  return (
    <StyledSideBarContent>
      <StyledMenu
        mode="inline"
        inlineCollapsed={isCollapsed}
        items={items}
        selectedKeys={selectedKeys}
      />
    </StyledSideBarContent>
  );
};
